import * as React from 'react';
import { Button, Modal, Form, Input, Checkbox } from 'antd';
import './style.less';

//Styling of the Layout
const formItemLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};
const formTailLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14, offset: 10 },
};

/**
 * Represents SendSMSModal Props Attributes
 */
interface SendSMSModalProps {
  open: boolean;
  proceeding: boolean;
  callerNumber?: string;
  onClose: () => void;
  onSend: () => void;
}

/**
 * This function returns the SMS feature Modal
 * @param props has all input parameters to load the Card
 * @returns JSX code for Pop-up Modal for the SMS feature of the Map
 */
export const SendSMSModal = ({ open, proceeding, callerNumber, onClose, onSend }: SendSMSModalProps): JSX.Element => {
  return (
    <Modal
      visible={open}
      closable={true}
      destroyOnClose
      mask
      maskClosable
      footer={null}
      getContainer={false}
      onCancel={onClose}
    >
      <div className="ant-modal--header">Send Message</div>
      <Form name="send_sms" className="send-sms-form">
        <Form.Item
          {...formItemLayout}
          name="number"
          label="Number to send message:"
          rules={[{ required: true, message: 'Please input phone number.' }]}
        >
          <Input defaultValue={callerNumber} placeholder="Phone number" disabled />
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          name="message"
          label="Message Text:"
          rules={[{ required: true, message: 'Please input your message.' }]}
        >
          <Input.TextArea placeholder="Message..." autoSize={{ minRows: 6, maxRows: 10 }} />
        </Form.Item>
        <Form.Item className="checkbox-group" {...formTailLayout}>
          <Checkbox>Preferred Pharmacies</Checkbox>
          <Checkbox>Calling Destination</Checkbox>
        </Form.Item>
        <Form.Item className="ant-modal--footer" {...formTailLayout}>
          <Button onClick={onClose}>Close</Button>
          <Button type="primary" htmlType="submit" loading={proceeding}>
            Send Now
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SendSMSModal;
